export default __webpack_public_path__ + "static/media/bull_coin.a523c5e1.svg";